<template>
  <div class="space-y-8">
    <ValidationProvider name="product type" rules="required" slim vid="productType">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Product Type </BaseFormLabel>
          <div class="space-y-2">
            <div class="flex items-center">
              <input
                id="simple-product"
                v-model="formData.productType"
                value="simple"
                name="product-type"
                type="radio"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
              />
              <label for="simple-product" class="ml-3 block text-sm font-medium text-gray-700">
                Simple
              </label>
            </div>
            <div class="flex items-center">
              <input
                id="virtual-product"
                v-model="formData.productType"
                value="virtual"
                name="product-type"
                type="radio"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
              />
              <label for="virtual-product" class="ml-3 block text-sm font-medium text-gray-700">
                Virtual
              </label>
            </div>
          </div>
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="product type" rules="required" slim vid="productType">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Use template </BaseFormLabel>
          <div class="space-y-2">
            <div class="flex items-center">
              <input
                id="without-template"
                name="use-template"
                v-model="useTemplate"
                :value="false"
                type="radio"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
              />
              <label for="without-template" class="ml-3 block text-sm font-medium text-gray-700">
                No
              </label>
            </div>
            <div class="flex items-center">
              <input
                id="with-template"
                name="use-template"
                v-model="useTemplate"
                :value="true"
                type="radio"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
              />
              <label for="with-template" class="ml-3 block text-sm font-medium text-gray-700">
                Yes
              </label>
            </div>
          </div>
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <AccProductTemplateSelect
      v-if="useTemplate"
      :key="formData.productType"
      v-model="formData.templateId"
      :product-type="formData.productType"
    />

    <ValidationProvider rules="required" name="name" slim vid="name">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Name </BaseFormLabel>
          <BaseFormInput type="text" v-model="formData.name" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import AccProductTemplateSelect from './AccProductTemplateSelect.vue';

export default {
  components: {
    AccProductTemplateSelect,
  },
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      formData: {
        name: '',
        templateId: null,
        productType: 'simple',
      },
      useTemplate: false,
      productTypeOptions: [
        { value: 'simple', label: 'Simple' },
        { value: 'virtual', label: 'Virtual' },
      ],
    };
  },
  watch: {
    'formData.productType': {
      handler() {
        this.formData.template = null;
      },
    },
    'formData.templateId': {
      handler(templateId) {
        if (!templateId) {
          return;
        }

        const template = this.$store.state.entities.accProductTemplates.byId[templateId];

        if (!template) {
          return;
        }

        this.formData.name = template.name;
      },
    },
    useTemplate() {
      this.formData.template = null;
    },
  },
  methods: {
    getFormData() {
      return cloneDeep(this.formData);
    },
  },
};
</script>
